import { createFileRoute } from '@tanstack/react-router';
import { Wallet } from 'lucide-react';
import { ComingSoon } from '@/components/layout/ComingSoon';

export const Route = createFileRoute('/_app/lancamentos/disponibilidades')({
  component: DisponibilidadesPage,
});

function DisponibilidadesPage() {
  return (
    <ComingSoon
      eyebrow="Lançamento · Mensal"
      title="Disponibilidades"
      description="Saldo bancário e investimentos do convênio no mês."
      icon={Wallet}
      bullets={[
        'Saldo de conta corrente e aplicações',
        'Extrato consolidado por banco',
        'Cálculo automático de rendimentos',
      ]}
      etaLabel="próxima fase"
    />
  );
}
